import { type GradientColorScale } from '../visualization/gradientTypes'

/**
 * Color scale for variance visualization.
 * Green = consistent, Yellow = moderate, Red = inconsistent.
 *
 * The per-metric variance pipeline this scale originally served was removed
 * (session-analysis overview now consumes trackGradient); this constant
 * survives because the sessionAnalysisV2 heatmap legend (web) still uses it.
 */
export const VARIANCE_COLOR_SCALE: GradientColorScale = {
  colors: ['#10B981', '#F59E0B', '#EF4444'], // green -> amber -> red
  labels: { min: 'Consistent', max: 'Inconsistent' },
  displayName: 'Variance',
  unit: '',
}
